var _dec, _dec2, _class, _class2, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import ArcGisPortalSharedTraits from "./ArcGisPortalSharedTraits";
import CatalogMemberReferenceTraits from "./CatalogMemberReferenceTraits";
import MappableTraits from "./MappableTraits";
import mixTraits from "../mixTraits";
import primitiveTrait from "../Decorators/primitiveTrait";
import UrlTraits from "./UrlTraits";
import { traitClass } from "../Trait";
let ArcGisPortalItemTraits = (_dec = traitClass({
  description: "Creates an item or group that references an item in ArcGIS portal.\n\n  <strong>Note:</strong> \n  <li>The <code>itemId</code> in the example is the referenced item's ID in the portal.</li>\n  <li>Not all referenced items can be added to the map. E.g., some types need conversions.</li>",
  example: {
    type: "arcgis-portal-item",
    itemId: "084c61c6dd404517bc2db69079ddec38",
    name: "NSW Administrative Theme",
    url: "https://portal.spatial.nsw.gov.au/portal",
    id: "some id"
  }
}), _dec2 = primitiveTrait({
  name: "Item ID",
  description: "The ID of the portal item.",
  type: "string"
}), _dec(_class = (_class2 = class ArcGisPortalItemTraits extends mixTraits(UrlTraits, MappableTraits, CatalogMemberReferenceTraits, ArcGisPortalSharedTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "itemId", _descriptor, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "itemId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);
export { ArcGisPortalItemTraits as default };